import React from 'react';
import FileUploadForm from '../../Forms/Formular/FileUploadForm';

const FileUploadPage: React.FC = () => {
  return (
    <>
      <div className="container">
        <div className="page-content-text">
          <p>
            Hier können die Excel-Dateien hochgeladen werden, die für
            die Auswertungen des Angebotsformulares genutzt werden
            können.
          </p>
        </div>
        <FileUploadForm></FileUploadForm>
      </div>
    </>
  );
};

export default FileUploadPage;
